<template>
  <v-card>
    <v-card-title class="justify-center">
      <span v-if="formType == 'viewForm' " class="text-h5">{{ $t('Project Document') }}</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <!--<material-card v-if="phaseType == 'planning' || phaseType == 'all' "
          icon="mdi-folder"
          icon-small
          :title="$t('Instruction Document')"
          color="accent"
        >
          <v-simple-table class="table">
            <thead>
              <tr>
                <th>{{ $t('Proposal') }}</th>
                <th>{{ $t('Feasibility Study') }}</th>
                <th>{{ $t('Design Report') }}</th>
                <th>{{ $t('Price Est.') }}</th>
                <th>{{ $t('Technical Opinions') }}</th>
                <th>{{ $t('Eval. Cert.') }}</th>
                <th>{{ $t('Economic Analysis') }}</th>
                <th>{{ $t('Env. Assessment') }}</th>
                <th>{{ $t('Change Project Status') }}</th>
              </tr>
            </thead>
            <tbody>
                <tr>
                  <td><v-icon v-if="project.project_documents && project.project_documents[0].original_name === 'No Document' ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents && project.project_documents[1].original_name === 'No Document' ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents && project.project_documents[2].original_name === 'No Document' ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents && project.project_documents[3].original_name === 'No Document' ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents && project.project_documents[4].original_name === 'No Document' ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents && project.project_documents[5].original_name === 'No Document' ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents && project.project_documents[6].original_name === 'No Document' ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents && project.project_documents[7].original_name === 'No Document' ">mdi-alert</v-icon></td>
                  <td>
                    <p>
                      <v-select
                        v-model="project.project_status_id"
                        :item-value="item=>item.id"
                        :item-text="item=>item.translation.name"
                        :items="projectApplicationStatusList"
                        :label="$t('Status')"
                      >
                        <template v-slot:item="{ item }">
                          <div>{{ getTranslation(item.translation.name) }}</div>
                        </template>
                      </v-select>
                    </p>
                    <p>
                      <input type="checkbox" id="national_assembly" v-model="project.validated_by_national_assembly" />
                      <label for="checkbox">   {{ $t('Project Approved by National Assemby') }}</label>
                    </p>
                    <p>
                      <v-btn
                        color="grey darken-1"
                        text
                        style="border:1px solid grey; margin: auto;"
                        v-on:click="close()"
                      >
                        {{ $t('Upload Evaluation Document') }}
                      </v-btn>
                      <span v-if="project.status ==='Approved'" style="margin-left:5px;border-bottom: 1px solid grey;">Evaluation Document.pdf</span>
                    </p>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>


          </material-card>-->








        <!--<material-card  
          v-if="phaseType == 'reporting' || phaseType == 'all' "
          icon="mdi-folder"
          icon-small
          :title="$t('Reporting Document')"
          color="accent"
        >
          <v-simple-table class="table">
            <thead>
              <tr>
                <th>{{ $t('Milestone') }}</th>
                <th>{{ $t('Milestone Date') }}</th>
                <th>{{ $t('Committee Agreement') }}</th>
                <th>{{ $t('Implementation Agreement') }}</th>
                <th>{{ $t('Contract') }}</th>
                <th>{{ $t('Work order') }}</th>
                <th>{{ $t('Inspection Record') }} </th>
                <th>{{ $t('Progress Report') }}</th>
                <th>{{ $t('Past Payment') }}</th>
                <th>{{ $t('Project Status') }}</th>
                <th>{{ $t('Milestone Status') }}</th>
              </tr>
            </thead>
            <tbody>
                <tr>
                  <td> {{ project.project_milestones[0].name }} </td>
                  <td> {{ new Date(project.project_milestones[0].completion_date).toLocaleDateString("en-GB") }} </td>
                  <td><v-icon v-if="project.project_documents.length !== 7 || (project.project_documents && project.project_documents[0].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents.length !== 7 || (project.project_documents && project.project_documents[1].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents.length !== 7 || (project.project_documents && project.project_documents[2].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents.length !== 7 || (project.project_documents && project.project_documents[3].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents.length !== 7 || (project.project_documents && project.project_documents[4].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents.length !== 7 || (project.project_documents && project.project_documents[5].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents.length !== 7 || (project.project_documents && project.project_documents[6].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td>{{ $t('On-Going') }}</td>
                  <td>
                    <v-select
                      v-model="project.project_milestones[0].milestone_status_id"
                      :items="milestoneStatusList"
                      :item-value="item=>item.id"
                      :item-text="item=>item.translation.name"
                      :label="$t('Milestone')"
                    >
                      <template v-slot:item="{ item }">
                        <div>{{ getTranslation(item.translation.name) }}</div>
                      </template>
                    </v-select>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </material-card>-->





          <!--<material-card 
            v-if="phaseType == 'completion' || phaseType == 'all' "
            icon="mdi-folder"
            icon-small
            :title="$t('Completion Document')"
            color="accent"
          >
          <v-simple-table class="table">
            <thead>
              <tr>
                <th>{{ $t('Project Completion Report') }}</th>
                <th>{{ $t('Final Evaluation Report') }}</th>
                <th>{{ $t('Temporary delivery-receipt certificate') }}</th>
                <th>{{ $t('Past Payment Information') }}</th>
                <th>{{ $t('Change Project Status') }}</th>
              </tr>
            </thead>
            <tbody>
                <tr>
                  <td><v-icon v-if="project.project_documents.length !== 4 || (project.project_documents && project.project_documents[0].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents.length !== 4 || (project.project_documents && project.project_documents[0].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents.length !== 4 || (project.project_documents && project.project_documents[0].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td><v-icon v-if="project.project_documents.length !== 4 || (project.project_documents && project.project_documents[0].original_name === 'No Document') ">mdi-alert</v-icon></td>
                  <td>
                    <v-select
                      v-model="project.project_status_id"
                      :item-value="item=>item.id"
                      :item-text="item=>item.translation.name"
                      :items="projectCompletionStatusList"
                      :label="$t('Status')"
                    >
                      <template v-slot:item="{ item }">
                        <div>{{ getTranslation(item.translation.name) }}</div>
                      </template>
                    </v-select>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </material-card>-->
          <material-card 
            v-if="phaseType == 'completion' || phaseType == 'all' "
            icon="mdi-currency-usd"
            icon-small
            :title="$t('VfM result')"
            color="accent"
          >

          <div class="row">
            <div style="margin: auto;">
              <!--<span>{{ $t('Rapid rebuilding of people\'s livelihoods:') }}</span>               
              <v-chip
                  :color="getColor({'realized': 6, 'objective': 9})"
                  dark
                >
                  1/6
              </v-chip>-->
              
            </div>
          </div>
          <!--<v-data-table 
            :headers="headers"
            :items="VFM_1" 
          >
            <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
              <span>{{ getHeader(header.text) }}</span>
            </template>
            
             <template v-slot:item.statement="{ item }">
                {{ getTranslation(item.statement) }}
            </template>
             <template v-slot:item.objective="{ item }">
                {{ getTranslation(item.objective) }}
            </template>
              <template v-slot:item.realized="{ item }">
                {{ getTranslation(item.realized) }}
            </template>
          </v-data-table>-->

          <div class="row">
            <div style="margin: auto;">{{ $t('Local industry & community participation') }}</span>              
              <v-chip
                  color="#e67300"
                  dark
                >
                  4/10
              </v-chip>
            </div>
          </div>
          <v-data-table 
            :headers="headers"
            :items="VFM_2" 
          >
            <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
               <span style="padding-left:200px;">{{ getHeader(header.text) }}</span>
            </template>
               <template v-slot:item.statement="{ item }">
                 <span style="padding-left:200px;">{{ getTranslation(item.statement) }}</span>
            </template>
             <template v-slot:item.objective="{ item }">
                 <span style="padding-left:200px;">{{ getTranslation(item.objective) }}</span>
            </template>
              <template v-slot:item.realized="{ item }">
                <span style="padding-left:200px;"> {{ getTranslation(item.realized) }}</span>
            </template>
          </v-data-table>

          <div class="row">
            <div style="margin: auto;">{{ $t('Design quality & Development Gains') }}</span>              
              <v-chip
                  :color="getColor({'realized': 10, 'objective': 9})"
                  dark
                >
                  2/2
              </v-chip>
            </div>
          </div>
          <v-data-table 
            :headers="headers"
            :items="VFM_3" 
          >
            <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
              <span style="padding-left:200px;">{{ getHeader(header.text) }}</span>
            </template>
               <template v-slot:item.statement="{ item }">
                <span style="padding-left:200px;">{{ getTranslation(item.statement) }}</span>
            </template>
             <template v-slot:item.objective="{ item }">
                <span style="padding-left:200px;">{{ getTranslation(item.objective) }}</span>
            </template>
              <template v-slot:item.realized="{ item }">
                   <span style="padding-left:200px;">{{ getTranslation(item.realized) }}</span>
            </template>
          </v-data-table>
          
         <div class="row">
            <div style="margin: auto;">{{ $t('VFM principles/Project lifecycle Efficiency, Effectiveness, Transparency, Sustainability') }}</span>              
              <v-chip
                  :color="getColor({'realized': 10, 'objective': 9})"
                  dark
                >
                  7/15
              </v-chip>
            </div>
          </div>
          <v-data-table 
            :headers="headers"
            :items="VFM_4" 
            :items-per-page="20"

          >
            <template v-for="header in headers" v-slot:[`header.${header.value}`]="{ header }">
              <span style="padding-left:200px;">{{ getHeader(header.text) }}</span>
            </template>
               <template v-slot:item.statement="{ item }">
                <span style="padding-left:200px;">{{ getTranslation(item.statement) }}</span>
            </template>
             <template v-slot:item.objective="{ item }">
                <span style="padding-left:200px;">{{ getTranslation(item.objective) }}</span>
            </template>
              <template v-slot:item.realized="{ item }">
                <span style="padding-left:200px;">{{ getTranslation(item.realized) }}</span>
            </template>
          </v-data-table>

          </material-card>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="grey darken-1"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'ApprovalForm',
    props: {
      project: {
        type: Object
      },
      formType: {
        type: String
      },
      phaseType: {
        type: String
      }
    },
    data: () => ({
      //status: 'Instruction',
      //applicationStatusList: ['Instruction','Approved','Rejected'],
      //completionStatusList: ['Temporary Approval','Not Approved','Final Approval'],
      //statusList: ['Instruction','Approved','Rejected','On-Going','Finished'],
      //MilestoneStatusList: ['Approved','On-Going','Rejected'],
      /*projectMiletoneStatus: [
      {
        id:1,
        project_id:1,
        milestone_1: 'On-Going'
      },{
        id:2,
        project_id:2,
        milestone_1: 'Approved'
      },{
        id:3,
        project_id:2,
        milestone_2: 'On-Going'
      }
      ],*/
      headers: [
        {
          sortable: true,
          text: 'Statement',
          align: 'left',
          value: 'statement',
        },  
        {
          sortable: true,
          text: 'Objective',
          align: 'center',
          value: 'objective',
        },        {
          sortable: true,
          text: 'Realized',
          align: 'center',
          value: 'realized',
        }
      ],
      /*VFM_1: [
        {
          statement: "Number of directly affected villages that the asset services",
          objective: 30,
          realized: 25
        },      
        {
          statement: "Number of directly affected people that the asset services",
          objective: 50,
          realized: 45
        },      
        {
          statement: "% of people in the district living below the poverty line",
          objective: 7,
          realized: 2
        },      
        {
          statement: "Total of directly affected villages consulted (pre-works)",
          objective: 52,
          realized: 3
        },      
        {
          statement: "Total of directly affected people consulted (pre-works)",
          objective: 50,
          realized: 50
        },      
        {
          statement: "Total of directly affected women consulted (pre-works)",
          objective: 36,
          realized: 10
        }
      ],*/
      VFM_2: [
      	{
          statement: "Number of directly affected villages consulted (Total consulted during completion)",
          objective: 35,
          realized: 35
        },  
        {
          statement: "Number of directly affected people consulted (Total consulted during completion)",
          objective: 35,
          realized: 35
        },  
        {
          statement: "Number of directly affected women consulted (Total consulted during completion",
          objective: 35,
          realized: 35
        },  
        {
          statement: "Number of local fully time staff (Actual final number)",
          objective: 35,
          realized: 35
        },  
        {
          statement: "Number of local fully time women staff (Actual final number)",
          objective: 35,
          realized: 35
        },  
        {
          statement: "Number of locally hired temporary labour-days",
          objective: 35,
          realized: 35
        },  
        {
          statement: "% of proposed locally hired temporary labour-days (women) (Actual final percentage)",
          objective: 35,
          realized: 35
        },        
        {
          statement: "Was the majority (>50%) of materials be locally sourced?",
          objective: 'Yes',
          realized: 'No'
        },      
        {
          statement: "Was the majority (>50%) of plant be locally sourced?",
          objective: 'Yes',
          realized: 'Yes'
        },      
        {
          statement: "Was a grievance of mechanisms be established at project commencement?",
          objective: 'Yes',
          realized: 'Yes'
        }
      ],
      VFM_3: [
        {
          statement: "Effective implementation of environmental social and safeguard process (Y/N)",
          objective: 'Yes',
          realized: 'Yes'
        }, 
        {
          statement: "Design Method Proposed",
          objective: "Build Back Better",
          realized: "Build Back Better"
        }
      ],
      VFM_4: [
      	{
      	  statement: "Overall Project Costs (mLAK)",
          objective: '10000',
          realized: '10000'
      	},
      	{
      	  statement: "Direct Project Costs (mLAK)",
          objective: '10000',
          realized: '10000'
      	},
      	{
      	  statement: "Indirect Project Costs (mLAK)",
          objective: '10000',
          realized: '10000'
      	},
      	{
      	  statement: "Project Management Costs (mLAK)",
          objective: '10000',
          realized: '10000'
      	},
      	{
      	  statement: "Design Cost (mLAK)",
          objective: '10000',
          realized: '10000'
      	},
      	{
      	  statement: "Contingency Cost (mLAK)",
          objective: '10000',
          realized: '10000'
      	},      	      	      	      	
      	{
      	  statement: "Cost Escalation(mLAK)",
          objective: '10000',
          realized: '10000'
      	},
      	{
      	  statement: "Risk identification to cost",
          objective: 'Yes',
          realized: 'Yes'
      	}, 
      	{
      	  statement: "Risk identification to scope",
          objective: 'Yes',
          realized: 'Yes'
      	}, 
      	{
      	  statement: "Risk identification to resources availability",
          objective: 'Yes',
          realized: 'Yes'
      	}, 
      	{
      	  statement: "Actual Start Date",
          objective: '20/12/2022',
          realized: '20/12/2022'
      	},       	
      	{
      	  statement: "Actual End Date",
          objective: '20/12/2023',
          realized: '20/12/2023'
      	},       	      	
      	{
      	  statement: "Schedule Risk",
          objective: 'Yes',
          realized: 'Yes'
      	}, 
      	{
      	  statement: "Has the final progress report been submitted ?",
          objective: 'Yes',
          realized: 'Yes'
      	},       	
      	{
      	  statement: "Expected Completion date ",
          objective: '20/12/2023',
          realized: '20/12/2023'
      	}
      ]
    }),
    computed: {
      projectApplicationStatusList() {
        return this.$store.state.referentials.projectApplicationStatusList;
      },
      projectCompletionStatusList() {
        return this.$store.state.referentials.projectCompletionStatusList;
      },
      milestoneStatusList() {
        return this.$store.state.referentials.milestoneStatusList;
      },
    },
    mounted: function(){
      console.log(this.project);
      if(this.phaseType == 'planning') {
        this.$store.dispatch('referentials/getProjectApplicationStatusList');
      }
      if(this.phaseType == 'reporting'){
        this.$store.dispatch('referentials/getMilestoneStatusList');
        //console.log(this.project);
      }
      if(this.phaseType == 'completion') {
        this.$store.dispatch('referentials/getProjectCompletionStatusList');
      }
    },
    methods: {
      getHeader(val) {
        return this.$t(val);
      },
      getTranslation(val) {
        return this.$t(val);
      },
      close: function(){
        //this.dialog_view = false;
        this.$emit('update:dialog', false)
      },
      save: function(){
        //console.log(this.project);
        if(this.phaseType == 'planning' || this.phaseType == 'completion') {
          this.$store.dispatch('projects/updateProjectStatus',this.project);
          //this.$store.dispatch('projects/getProjectListApplication');
        }
        if(this.phaseType == 'reporting'){
          this.$store.dispatch('projects/updateProjectMilestoneStatus',this.project);
          this.$store.dispatch('projects/getProjectOnGoingList');
        }
        if(this.phaseType == 'planning'){
          this.$store.dispatch('projects/getProjectListApplication');
        }
        if(this.phaseType == 'completion'){
          this.$store.dispatch('projects/getProjectCompletedList');
        }
        /*if (this.phaseType == 'completion') {
          this.$store.dispatch('projects/updateProjectApplicationStatus',this.project);
          this.$store.dispatch('projects/getProjectListApplication');
        }*/
        this.$emit('update:dialog', false)
      },
      getColor (item) {
        if (typeof item.realized === "string"){
          if (item.realized !== item.objective) return 'red'
          else if (item.realized === item.objective) return 'green'
        }else {
          if (item.realized < item.objective) return 'red'
          else if (item.realized >= item.objective) return 'green'
        }
      },
    }
  }
</script>
<style>
  .table td {
    text-align: center;
  }

</style>
